import L from 'leaflet';
import { createControlComponent } from '@react-leaflet/core';
import 'leaflet.locatecontrol/dist/L.Control.Locate.min.css';
import 'leaflet.locatecontrol/dist/L.Control.Locate.min';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const GeolocationControl = createControlComponent((props: L.Control.LocateOptions) => L.control.locate(props));
